import { render } from "./stock-indicator.vue?vue&type=template&id=bd525a3a&ts=true"
import script from "./stock-indicator.vue?vue&type=script&lang=ts"
export * from "./stock-indicator.vue?vue&type=script&lang=ts"

import "./stock-indicator.vue?vue&type=style&index=0&id=bd525a3a&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__